export const moveTo = {
	init: () => {
		const elementsToMove = document.querySelectorAll( '[data-move-to]' );
		elementsToMove.forEach( ( elmt ) => {
			const moveToDestination = document.querySelector( elmt.dataset.moveTo );
			moveToDestination.appendChild( elmt );
		} );
	},
};
